import React from 'react';
import { FadeIn } from './FadeIn';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    icon: '💬',
    title: 'Cierre Express PVC',
    desc: 'Las 15 respuestas exactas para cerrar obras sin bajar el precio. Scripts de WhatsApp listos para copiar.',
    value: '$8.990'
  }, {
    num: '02',
    icon: '🚨',
    title: 'Mapa de Errores Fatales',
    desc: 'Los 10 errores más caros del rubro con causa, consecuencia y solución exacta.',
    value: '$6.990'
  }, {
    num: '03',
    icon: '⭐',
    title: 'Guía de Entrega Premium',
    desc: 'Protocolo de 7 pasos para entregar como profesional y convertir clientes en recomendaciones.',
    value: '$5.990'
  }];
  return <section className="py-16 relative" data-id="element-18">
      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-19">
        <FadeIn data-id="element-20">
          <div className="text-center mb-12" data-id="element-21">
            <h2 className="text-3xl md:text-5xl font-heading font-bold mb-4 text-white" data-id="element-22">
              🎁 PACK DE BONOS
            </h2>
            <p className="text-gold text-xl font-bold uppercase tracking-wider mb-4" data-id="element-23">
              SIEMPRE INCLUIDOS
            </p>
          </div>
        </FadeIn>

        <div className="space-y-4 mb-12" data-id="element-24">
          {bonuses.map((bono, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-25">
              <div className="bg-surface p-6 md:p-8 rounded-2xl border border-white/5 flex flex-col md:flex-row md:items-center justify-between gap-6 hover:border-gold/30 transition-colors" data-id="element-26">
                <div className="flex items-start gap-4" data-id="element-27">
                  <span className="text-2xl font-heading font-bold text-gold opacity-50 mt-1" data-id="element-28">
                    {bono.num}
                  </span>
                  <div data-id="element-29">
                    <h3 className="text-lg font-heading font-bold text-white mb-2" data-id="element-30">
                      {bono.icon} BONO {i + 1} — {bono.title}
                    </h3>
                    <p className="text-gray-400 text-sm md:text-base" data-id="element-31">
                      {bono.desc}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3 md:flex-col md:items-end md:gap-1 shrink-0" data-id="element-32">
                  <span className="text-gray-500 line-through text-sm" data-id="element-33">
                    Valor: {bono.value}
                  </span>
                  <span className="bg-gold text-bg font-bold px-3 py-1 rounded-md text-sm uppercase tracking-wide" data-id="element-34">
                    GRATIS
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-35">
          <div className="text-center p-8 rounded-2xl bg-gradient-to-r from-surface to-surfaceLight border border-gold/20" data-id="element-36">
            <p className="text-xl md:text-2xl font-medium text-white" data-id="element-37">
              Valor total de los bonos:{' '}
              <span className="line-through text-gray-500" data-id="element-38">$21.970</span>{' '}
              <span className="text-gold font-bold" data-id="element-39">
                → GRATIS con tu Sistema Maestro
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}